import { render, staticRenderFns } from "./UpliftData.vue?vue&type=template&id=65370f32&scoped=true"
import script from "./UpliftData.vue?vue&type=script&lang=js"
export * from "./UpliftData.vue?vue&type=script&lang=js"
import style0 from "./UpliftData.vue?vue&type=style&index=0&id=65370f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65370f32",
  null
  
)

export default component.exports